"use strict";
exports.__esModule = true;
exports.EMBED_SIMPLIFIED_PAYMENTS = void 0;
exports.EMBED_SIMPLIFIED_PAYMENTS = {
    HEADER: 'Pay your rent',
    BODY: "Ready to pay your rent? Here's what we'll do to make it happen.",
    FIRST_PAYMENT_HEADER: 'Flex will collect your {{paymentType}}',
    FIRST_PAYMENT_DUE: 'Due now',
    FLEX_RENT_HEADER: 'Flex will start processing your full rent payment',
    FLEX_RENT_PAY_TO: 'Pay to',
    FLEX_RENT_AMOUNT: 'Amount',
    SECOND_PAYMENT_HEADER: 'Your 2nd payment is scheduled for {{dueDate}}',
    SECOND_PAYMENT_DUE: '{{dueDate}}',
    CTA: 'Start payment'
};
